class PensionDetails {

    constructor() {
        this.registerEvents();
    }

    registerEvents() {
        $(document).on('change', '[name="pension[scheme]"]', e => {
            this.updateScheme($(e.currentTarget));
        });

        return $(document).ready(() => {
            this.updateScheme($('select[name="pension[scheme]"]'));
            if (typeof (Locum.oldInput) !== 'undefined') {
                this.populateFields(Locum.oldInput.pension);
            }
        });
    }

    updateScheme(s) {
        // Get the selected scheme
        const scheme = s.val();
        // Update the fields if scheme has value
        if (scheme) {
            return this.updateSchemeFields(scheme);
        }
    }

    updateSchemeFields(scheme) {
        // Update the fields to the desired field
        $('#form-fields').html(require('../../templates/PensionFields.html')({ scheme }));
        return Global.tooltips();
    }

    populateFields(oldInput) {
        return (() => {
            const result = [];
            for (const name in oldInput) {
                const value = oldInput[name];
                const field = $(`[name=\"pension[${ name }]\"]`);
                if (field.length) {
                    result.push(field.val(value));
                } else {
                    result.push(undefined);
                }
            }
            return result;
        })();
    }
}

export default PensionDetails;
